export const STORE_ARRAYS  =  [
  {
    "storeId": "1234",
    "storeName": "Test_discount",
    "hadDiscount": true,
    "discountAmount": 10
  },
  {
    "storeId": "12345",
    "storeName": "Test_discount",
    "hadDiscount": true,
    "discountAmount": 5
  },
  {
    "storeId": "4321",
    "storeName": "Test_Nodiscount",
    "hadDiscount": false,
    "discountAmount": 0
  },
  {
    "storeId": "2120815",
    "storeName": "_shop_2120815_",
    "hadDiscount": false,
    "discountAmount": 0
  },
  {
    "storeId": "2486550",
    "storeName": "_shop_2486550_",
    "hadDiscount": false,
    "discountAmount": 0
  },
  {
    "storeId": "2121054",
    "storeName": "_shop_2121054_",
    "hadDiscount": false,
    "discountAmount": 0
  },
  {
    "storeId": "2463387",
    "storeName": "_shop_2463387_",
    "hadDiscount": false,
    "discountAmount": 0
  },
  {
    "storeId": "2387355",
    "storeName": "_shop_2387355_",
    "hadDiscount": false,
    "discountAmount": 0
  },
  {
    "storeId": "2524652",
    "storeName": "_shop_2524652_",
    "hadDiscount": false,
    "discountAmount": 0
  },
  {
    "storeId": "2121243",
    "storeName": "_shop_2121243_",
    "hadDiscount": false,
    "discountAmount": 0
  },
  {
    "storeId": "2525071",
    "storeName": "_shop_2525071_",
    "hadDiscount": false,
    "discountAmount": 0
  },
  {
    "storeId": "2558541",
    "storeName": "_shop_2558541_",
    "hadDiscount": false,
    "discountAmount": 0
  },
  {
    "storeId": "2344953",
    "storeName": "_shop_2344953_",
    "hadDiscount": false,
    "discountAmount": 0
  },
  {
    "storeId": "2397270",
    "storeName": "_shop_2397270_",
    "hadDiscount": false,
    "discountAmount": 0
  },
  {
    "storeId": "2120227",
    "storeName": "_shop_2120227_",
    "hadDiscount": false,
    "discountAmount": 0
  },
  {
    "storeId": "2120978",
    "storeName": "_shop_2120978_",
    "hadDiscount": false,
    "discountAmount": 0
  },
  {
    "storeId": "2121770",
    "storeName": "_shop_2121770_",
    "hadDiscount": false,
    "discountAmount": 0
  },
  {
    "storeId": "2120983",
    "storeName": "_shop_2120983_",
    "hadDiscount": false,
    "discountAmount": 0
  },
  {
    "storeId": "2509420",
    "storeName": "_shop_2509420_",
    "hadDiscount": false,
    "discountAmount": 0
  },
  {
    "storeId": "2513107",
    "storeName": "_shop_2513107_",
    "hadDiscount": false,
    "discountAmount": 0
  },
  {
    "storeId": "2344959",
    "storeName": "_shop_2344959_",
    "hadDiscount": false,
    "discountAmount": 0
  },
  {
    "storeId": "2466679",
    "storeName": "_shop_2466679_",
    "hadDiscount": false,
    "discountAmount": 0
  },
  {
    "storeId": "2540602",
    "storeName": "_shop_2540602_",
    "hadDiscount": false,
    "discountAmount": 0
  },
  {
    "storeId": "2560024",
    "storeName": "_shop_2560024_",
    "hadDiscount": false,
    "discountAmount": 0
  },
  {
    "storeId": "2121201",
    "storeName": "_shop_2121201_",
    "hadDiscount": false,
    "discountAmount": 0
  },
  {
    "storeId": "2121454",
    "storeName": "_shop_2121454_",
    "hadDiscount": false,
    "discountAmount": 0
  },
  {
    "storeId": "2120778",
    "storeName": "_shop_2120778_",
    "hadDiscount": false,
    "discountAmount": 0
  },
  {
    "storeId": "2121443",
    "storeName": "_shop_2121443_",
    "hadDiscount": false,
    "discountAmount": 0
  },
  {
    "storeId": "2120599",
    "storeName": "_shop_2120599_",
    "hadDiscount": false,
    "discountAmount": 0
  },
  {
    "storeId": "2121753",
    "storeName": "_shop_2121753_",
    "hadDiscount": false,
    "discountAmount": 0
  },
  {
    "storeId": "2515590",
    "storeName": "_shop_2515590_",
    "hadDiscount": false,
    "discountAmount": 0
  },
  {
    "storeId": "2120784",
    "storeName": "_shop_2120784_",
    "hadDiscount": false,
    "discountAmount": 0
  },
  {
    "storeId": "2120887",
    "storeName": "_shop_2120887_",
    "hadDiscount": false,
    "discountAmount": 0
  },
  {
    "storeId": "2462479",
    "storeName": "_shop_2462479_",
    "hadDiscount": false,
    "discountAmount": 0
  },
  {
    "storeId": "2506894",
    "storeName": "_shop_2506894_",
    "hadDiscount": false,
    "discountAmount": 0
  },
  {
    "storeId": "2524623",
    "storeName": "_shop_2524623_",
    "hadDiscount": false,
    "discountAmount": 0
  },
  {
    "storeId": "2120982",
    "storeName": "_shop_2120982_",
    "hadDiscount": false,
    "discountAmount": 0
  },
  {
    "storeId": "2441554",
    "storeName": "_shop_2441554_",
    "hadDiscount": false,
    "discountAmount": 0
  },
  {
    "storeId": "2153726",
    "storeName": "_shop_2153726_",
    "hadDiscount": false,
    "discountAmount": 0
  },
  {
    "storeId": "2386930",
    "storeName": "_shop_2386930_",
    "hadDiscount": false,
    "discountAmount": 0
  },
  {
    "storeId": "2482471",
    "storeName": "_shop_2482471_",
    "hadDiscount": false,
    "discountAmount": 0
  },
  {
    "storeId": "2349370",
    "storeName": "_shop_2349370_",
    "hadDiscount": false,
    "discountAmount": 0
  },
  {
    "storeId": "2496075",
    "storeName": "_shop_2496075_",
    "hadDiscount": false,
    "discountAmount": 0
  },
  {
    "storeId": "2545805",
    "storeName": "_shop_2545805_",
    "hadDiscount": false,
    "discountAmount": 0
  },
  {
    "storeId": "2120629",
    "storeName": "_shop_2120629_",
    "hadDiscount": false,
    "discountAmount": 0
  },
  {
    "storeId": "2121441",
    "storeName": "_shop_2121441_",
    "hadDiscount": false,
    "discountAmount": 0
  },
  {
    "storeId": "2524725",
    "storeName": "_shop_2524725_",
    "hadDiscount": false,
    "discountAmount": 0
  },
  {
    "storeId": "2553050",
    "storeName": "_shop_2553050_",
    "hadDiscount": false,
    "discountAmount": 0
  },
  {
    "storeId": "2514260",
    "storeName": "_shop_2514260_",
    "hadDiscount": false,
    "discountAmount": 0
  },
  {
    "storeId": "2549979",
    "storeName": "_shop_2549979_",
    "hadDiscount": false,
    "discountAmount": 0
  },
  {
    "storeId": "2120979",
    "storeName": "_shop_2120979_",
    "hadDiscount": false,
    "discountAmount": 0
  },
  {
    "storeId": "2162796",
    "storeName": "_shop_2162796_",
    "hadDiscount": false,
    "discountAmount": 0
  },
  {
    "storeId": "2464313",
    "storeName": "_shop_2464313_",
    "hadDiscount": false,
    "discountAmount": 0
  },
  {
    "storeId": "2120474",
    "storeName": "_shop_2120474_",
    "hadDiscount": false,
    "discountAmount": 0
  },
  {
    "storeId": "2121945",
    "storeName": "_shop_2121945_",
    "hadDiscount": false,
    "discountAmount": 0
  },
  {
    "storeId": "2120545",
    "storeName": "_shop_2120545_",
    "hadDiscount": false,
    "discountAmount": 0
  },
  {
    "storeId": "2354756",
    "storeName": "_shop_2354756_",
    "hadDiscount": false,
    "discountAmount": 0
  },
  {
    "storeId": "2465522",
    "storeName": "_shop_2465522_",
    "hadDiscount": false,
    "discountAmount": 0
  },
  {
    "storeId": "2488413",
    "storeName": "_shop_2488413_",
    "hadDiscount": false,
    "discountAmount": 0
  },
  {
    "storeId": "2120514",
    "storeName": "_shop_2120514_",
    "hadDiscount": false,
    "discountAmount": 0
  },
  {
    "storeId": "2120875",
    "storeName": "_shop_2120875_",
    "hadDiscount": false,
    "discountAmount": 0
  },
  {
    "storeId": "2120882",
    "storeName": "_shop_2120882_",
    "hadDiscount": false,
    "discountAmount": 0
  },
  {
    "storeId": "2153736",
    "storeName": "_shop_2153736_",
    "hadDiscount": false,
    "discountAmount": 0
  },
  {
    "storeId": "2556885",
    "storeName": "_shop_2556885_",
    "hadDiscount": false,
    "discountAmount": 0
  },
  {
    "storeId": "2120860",
    "storeName": "_shop_2120860_",
    "hadDiscount": false,
    "discountAmount": 0
  },
  {
    "storeId": "2120993",
    "storeName": "_shop_2120993_",
    "hadDiscount": false,
    "discountAmount": 0
  },
  {
    "storeId": "2554392",
    "storeName": "_shop_2554392_",
    "hadDiscount": false,
    "discountAmount": 0
  },
  {
    "storeId": "2120600",
    "storeName": "_shop_2120600_",
    "hadDiscount": false,
    "discountAmount": 0
  },
  {
    "storeId": "2120631",
    "storeName": "_shop_2120631_",
    "hadDiscount": false,
    "discountAmount": 0
  },
  {
    "storeId": "2154534",
    "storeName": "_shop_2154534_",
    "hadDiscount": false,
    "discountAmount": 0
  },
  {
    "storeId": "2455607",
    "storeName": "_shop_2455607_",
    "hadDiscount": false,
    "discountAmount": 0
  },
  {
    "storeId": "2275179",
    "storeName": "_shop_2275179_",
    "hadDiscount": false,
    "discountAmount": 0
  },
  {
    "storeId": "2376643",
    "storeName": "_shop_2376643_",
    "hadDiscount": false,
    "discountAmount": 0
  },
  {
    "storeId": "2510380",
    "storeName": "_shop_2510380_",
    "hadDiscount": false,
    "discountAmount": 0
  },
  {
    "storeId": "2524459",
    "storeName": "_shop_2524459_",
    "hadDiscount": false,
    "discountAmount": 0
  },
  {
    "storeId": "2544702",
    "storeName": "_shop_2544702_",
    "hadDiscount": false,
    "discountAmount": 0
  },
  {
    "storeId": "2120597",
    "storeName": "_shop_2120597_",
    "hadDiscount": false,
    "discountAmount": 0
  },
  {
    "storeId": "2120995",
    "storeName": "_shop_2120995_",
    "hadDiscount": false,
    "discountAmount": 0
  },
  {
    "storeId": "2121442",
    "storeName": "_shop_2121442_",
    "hadDiscount": false,
    "discountAmount": 0
  },
  {
    "storeId": "2121748",
    "storeName": "_shop_2121748_",
    "hadDiscount": false,
    "discountAmount": 0
  },
  {
    "storeId": "2333491",
    "storeName": "_shop_2333491_",
    "hadDiscount": false,
    "discountAmount": 0
  },
  {
    "storeId": "2516080",
    "storeName": "_shop_2516080_",
    "hadDiscount": false,
    "discountAmount": 0
  },
  {
    "storeId": "2120915",
    "storeName": "_shop_2120915_",
    "hadDiscount": false,
    "discountAmount": 0
  },
  {
    "storeId": "2121153",
    "storeName": "_shop_2121153_",
    "hadDiscount": false,
    "discountAmount": 0
  },
  {
    "storeId": "2121765",
    "storeName": "_shop_2121765_",
    "hadDiscount": false,
    "discountAmount": 0
  },
  {
    "storeId": "2514263",
    "storeName": "_shop_2514263_",
    "hadDiscount": false,
    "discountAmount": 0
  },
  {
    "storeId": "2120818",
    "storeName": "_shop_2120818_",
    "hadDiscount": false,
    "discountAmount": 0
  },
  {
    "storeId": "2120918",
    "storeName": "_shop_2120918_",
    "hadDiscount": false,
    "discountAmount": 0
  },
  {
    "storeId": "2121719",
    "storeName": "_shop_2121719_",
    "hadDiscount": false,
    "discountAmount": 0
  },
  {
    "storeId": "2121759",
    "storeName": "_shop_2121759_",
    "hadDiscount": false,
    "discountAmount": 0
  },
  {
    "storeId": "2340020",
    "storeName": "_shop_2340020_",
    "hadDiscount": false,
    "discountAmount": 0
  },
  {
    "storeId": "2546986",
    "storeName": "_shop_2546986_",
    "hadDiscount": false,
    "discountAmount": 0
  },
  {
    "storeId": "2121185",
    "storeName": "_shop_2121185_",
    "hadDiscount": false,
    "discountAmount": 0
  },
  {
    "storeId": "2121826",
    "storeName": "_shop_2121826_",
    "hadDiscount": false,
    "discountAmount": 0
  },
  {
    "storeId": "2363788",
    "storeName": "_shop_2363788_",
    "hadDiscount": false,
    "discountAmount": 0
  },
  {
    "storeId": "2511766",
    "storeName": "_shop_2511766_",
    "hadDiscount": false,
    "discountAmount": 0
  },
  {
    "storeId": "2121022",
    "storeName": "_shop_2121022_",
    "hadDiscount": false,
    "discountAmount": 0
  },
  {
    "storeId": "2121032",
    "storeName": "_shop_2121032_",
    "hadDiscount": false,
    "discountAmount": 0
  },
  {
    "storeId": "2330137",
    "storeName": "_shop_2330137_",
    "hadDiscount": false,
    "discountAmount": 0
  },
  {
    "storeId": "2399075",
    "storeName": "_shop_2399075_",
    "hadDiscount": false,
    "discountAmount": 0
  },
  {
    "storeId": "2464127",
    "storeName": "_shop_2464127_",
    "hadDiscount": false,
    "discountAmount": 0
  },
  {
    "storeId": "2468279",
    "storeName": "_shop_2468279_",
    "hadDiscount": false,
    "discountAmount": 0
  },
  {
    "storeId": "2488803",
    "storeName": "_shop_2488803_",
    "hadDiscount": false,
    "discountAmount": 0
  },
  {
    "storeId": "2496117",
    "storeName": "_shop_2496117_",
    "hadDiscount": false,
    "discountAmount": 0
  },
  {
    "storeId": "2515594",
    "storeName": "_shop_2515594_",
    "hadDiscount": false,
    "discountAmount": 0
  },
  {
    "storeId": "2121035",
    "storeName": "_shop_2121035_",
    "hadDiscount": false,
    "discountAmount": 0
  },
  {
    "storeId": "2121154",
    "storeName": "_shop_2121154_",
    "hadDiscount": false,
    "discountAmount": 0
  },
  {
    "storeId": "2464585",
    "storeName": "_shop_2464585_",
    "hadDiscount": false,
    "discountAmount": 0
  },
  {
    "storeId": "2120482",
    "storeName": "_shop_2120482_",
    "hadDiscount": false,
    "discountAmount": 0
  },
  {
    "storeId": "2120830",
    "storeName": "_shop_2120830_",
    "hadDiscount": false,
    "discountAmount": 0
  },
  {
    "storeId": "2121819",
    "storeName": "_shop_2121819_",
    "hadDiscount": false,
    "discountAmount": 0
  },
  {
    "storeId": "2167854",
    "storeName": "_shop_2167854_",
    "hadDiscount": false,
    "discountAmount": 0
  },
  {
    "storeId": "2390021",
    "storeName": "_shop_2390021_",
    "hadDiscount": false,
    "discountAmount": 0
  },
  {
    "storeId": "2553786",
    "storeName": "_shop_2553786_",
    "hadDiscount": false,
    "discountAmount": 0
  },
  {
    "storeId": "2120984",
    "storeName": "_shop_2120984_",
    "hadDiscount": false,
    "discountAmount": 0
  },
  {
    "storeId": "2153728",
    "storeName": "_shop_2153728_",
    "hadDiscount": false,
    "discountAmount": 0
  },
  {
    "storeId": "2529066",
    "storeName": "_shop_2529066_",
    "hadDiscount": false,
    "discountAmount": 0
  },
  {
    "storeId": "2120782",
    "storeName": "_shop_2120782_",
    "hadDiscount": false,
    "discountAmount": 0
  },
  {
    "storeId": "2120787",
    "storeName": "_shop_2120787_",
    "hadDiscount": false,
    "discountAmount": 0
  },
  {
    "storeId": "2121313",
    "storeName": "_shop_2121313_",
    "hadDiscount": false,
    "discountAmount": 0
  },
  {
    "storeId": "2121772",
    "storeName": "_shop_2121772_",
    "hadDiscount": false,
    "discountAmount": 0
  },
  {
    "storeId": "2153713",
    "storeName": "_shop_2153713_",
    "hadDiscount": false,
    "discountAmount": 0
  },
  {
    "storeId": "2344958",
    "storeName": "_shop_2344958_",
    "hadDiscount": false,
    "discountAmount": 0
  },
  {
    "storeId": "2378226",
    "storeName": "_shop_2378226_",
    "hadDiscount": false,
    "discountAmount": 0
  },
  {
    "storeId": "2559587",
    "storeName": "_shop_2559587_",
    "hadDiscount": false,
    "discountAmount": 0
  },
  {
    "storeId": "2120602",
    "storeName": "_shop_2120602_",
    "hadDiscount": false,
    "discountAmount": 0
  },
  {
    "storeId": "2121169",
    "storeName": "_shop_2121169_",
    "hadDiscount": false,
    "discountAmount": 0
  },
  {
    "storeId": "2121786",
    "storeName": "_shop_2121786_",
    "hadDiscount": false,
    "discountAmount": 0
  },
  {
    "storeId": "2121797",
    "storeName": "_shop_2121797_",
    "hadDiscount": false,
    "discountAmount": 0
  },
  {
    "storeId": "2121824",
    "storeName": "_shop_2121824_",
    "hadDiscount": false,
    "discountAmount": 0
  },
  {
    "storeId": "2405804",
    "storeName": "_shop_2405804_",
    "hadDiscount": false,
    "discountAmount": 0
  },
  {
    "storeId": "2463520",
    "storeName": "_shop_2463520_",
    "hadDiscount": false,
    "discountAmount": 0
  },
  {
    "storeId": "2465388",
    "storeName": "_shop_2465388_",
    "hadDiscount": false,
    "discountAmount": 0
  },
  {
    "storeId": "2545569",
    "storeName": "_shop_2545569_",
    "hadDiscount": false,
    "discountAmount": 0
  },
  {
    "storeId": "2552071",
    "storeName": "_shop_2552071_",
    "hadDiscount": false,
    "discountAmount": 0
  },
  {
    "storeId": "2120797",
    "storeName": "_shop_2120797_",
    "hadDiscount": false,
    "discountAmount": 0
  },
  {
    "storeId": "2121550",
    "storeName": "_shop_2121550_",
    "hadDiscount": false,
    "discountAmount": 0
  },
  {
    "storeId": "2121793",
    "storeName": "_shop_2121793_",
    "hadDiscount": false,
    "discountAmount": 0
  },
  {
    "storeId": "2154582",
    "storeName": "_shop_2154582_",
    "hadDiscount": false,
    "discountAmount": 0
  },
  {
    "storeId": "2167618",
    "storeName": "_shop_2167618_",
    "hadDiscount": false,
    "discountAmount": 0
  },
  {
    "storeId": "2280722",
    "storeName": "_shop_2280722_",
    "hadDiscount": false,
    "discountAmount": 0
  },
  {
    "storeId": "2544549",
    "storeName": "_shop_2544549_",
    "hadDiscount": false,
    "discountAmount": 0
  },
  {
    "storeId": "2120785",
    "storeName": "_shop_2120785_",
    "hadDiscount": false,
    "discountAmount": 0
  },
  {
    "storeId": "2120804",
    "storeName": "_shop_2120804_",
    "hadDiscount": false,
    "discountAmount": 0
  },
  {
    "storeId": "2121801",
    "storeName": "_shop_2121801_",
    "hadDiscount": false,
    "discountAmount": 0
  },
  {
    "storeId": "2121823",
    "storeName": "_shop_2121823_",
    "hadDiscount": false,
    "discountAmount": 0
  },
  {
    "storeId": "2349367",
    "storeName": "_shop_2349367_",
    "hadDiscount": false,
    "discountAmount": 0
  },
  {
    "storeId": "2120879",
    "storeName": "_shop_2120879_",
    "hadDiscount": false,
    "discountAmount": 0
  },
  {
    "storeId": "2121446",
    "storeName": "_shop_2121446_",
    "hadDiscount": false,
    "discountAmount": 0
  },
  {
    "storeId": "2121825",
    "storeName": "_shop_2121825_",
    "hadDiscount": false,
    "discountAmount": 0
  },
  {
    "storeId": "2159416",
    "storeName": "_shop_2159416_",
    "hadDiscount": false,
    "discountAmount": 0
  },
  {
    "storeId": "2164312",
    "storeName": "_shop_2164312_",
    "hadDiscount": false,
    "discountAmount": 0
  },
  {
    "storeId": "2271888",
    "storeName": "_shop_2271888_",
    "hadDiscount": false,
    "discountAmount": 0
  },
  {
    "storeId": "2320698",
    "storeName": "_shop_2320698_",
    "hadDiscount": false,
    "discountAmount": 0
  },
  {
    "storeId": "2479375",
    "storeName": "_shop_2479375_",
    "hadDiscount": false,
    "discountAmount": 0
  },
  {
    "storeId": "2516081",
    "storeName": "_shop_2516081_",
    "hadDiscount": false,
    "discountAmount": 0
  },
  {
    "storeId": "2521533",
    "storeName": "_shop_2521533_",
    "hadDiscount": false,
    "discountAmount": 0
  },
  {
    "storeId": "2523578",
    "storeName": "_shop_2523578_",
    "hadDiscount": false,
    "discountAmount": 0
  },
  {
    "storeId": "2524452",
    "storeName": "_shop_2524452_",
    "hadDiscount": false,
    "discountAmount": 0
  },
  {
    "storeId": "2557163",
    "storeName": "_shop_2557163_",
    "hadDiscount": false,
    "discountAmount": 0
  },
  {
    "storeId": "2120481",
    "storeName": "_shop_2120481_",
    "hadDiscount": false,
    "discountAmount": 0
  },
  {
    "storeId": "2120793",
    "storeName": "_shop_2120793_",
    "hadDiscount": false,
    "discountAmount": 0
  },
  {
    "storeId": "2121126",
    "storeName": "_shop_2121126_",
    "hadDiscount": false,
    "discountAmount": 0
  },
  {
    "storeId": "2121155",
    "storeName": "_shop_2121155_",
    "hadDiscount": false,
    "discountAmount": 0
  },
  {
    "storeId": "2441646",
    "storeName": "_shop_2441646_",
    "hadDiscount": false,
    "discountAmount": 0
  },
  {
    "storeId": "2120477",
    "storeName": "_shop_2120477_",
    "hadDiscount": false,
    "discountAmount": 0
  },
  {
    "storeId": "2120791",
    "storeName": "_shop_2120791_",
    "hadDiscount": false,
    "discountAmount": 0
  },
  {
    "storeId": "2120917",
    "storeName": "_shop_2120917_",
    "hadDiscount": false,
    "discountAmount": 0
  },
  {
    "storeId": "2121015",
    "storeName": "_shop_2121015_",
    "hadDiscount": false,
    "discountAmount": 0
  },
  {
    "storeId": "2121044",
    "storeName": "_shop_2121044_",
    "hadDiscount": false,
    "discountAmount": 0
  },
  {
    "storeId": "2121529",
    "storeName": "_shop_2121529_",
    "hadDiscount": false,
    "discountAmount": 0
  },
  {
    "storeId": "2155977",
    "storeName": "_shop_2155977_",
    "hadDiscount": false,
    "discountAmount": 0
  },
  {
    "storeId": "2165016",
    "storeName": "_shop_2165016_",
    "hadDiscount": false,
    "discountAmount": 0
  },
  {
    "storeId": "2314530",
    "storeName": "_shop_2314530_",
    "hadDiscount": false,
    "discountAmount": 0
  },
  {
    "storeId": "2334810",
    "storeName": "_shop_2334810_",
    "hadDiscount": false,
    "discountAmount": 0
  },
  {
    "storeId": "2341638",
    "storeName": "_shop_2341638_",
    "hadDiscount": false,
    "discountAmount": 0
  },
  {
    "storeId": "2364170",
    "storeName": "_shop_2364170_",
    "hadDiscount": false,
    "discountAmount": 0
  },
  {
    "storeId": "2371842",
    "storeName": "_shop_2371842_",
    "hadDiscount": false,
    "discountAmount": 0
  },
  {
    "storeId": "2392890",
    "storeName": "_shop_2392890_",
    "hadDiscount": false,
    "discountAmount": 0
  },
  {
    "storeId": "2458972",
    "storeName": "_shop_2458972_",
    "hadDiscount": false,
    "discountAmount": 0
  },
  {
    "storeId": "2482892",
    "storeName": "_shop_2482892_",
    "hadDiscount": false,
    "discountAmount": 0
  },
  {
    "storeId": "2489436",
    "storeName": "_shop_2489436_",
    "hadDiscount": false,
    "discountAmount": 0
  },
  {
    "storeId": "2524621",
    "storeName": "_shop_2524621_",
    "hadDiscount": false,
    "discountAmount": 0
  },
  {
    "storeId": "2333787",
    "storeName": "_shop_2333787_",
    "hadDiscount": false,
    "discountAmount": 0
  },
  {
    "storeId": "2340021",
    "storeName": "_shop_2340021_",
    "hadDiscount": false,
    "discountAmount": 0
  },
  {
    "storeId": "2407991",
    "storeName": "_shop_2407991_",
    "hadDiscount": false,
    "discountAmount": 0
  },
  {
    "storeId": "2446586",
    "storeName": "_shop_2446586_",
    "hadDiscount": false,
    "discountAmount": 0
  },
  {
    "storeId": "2453267",
    "storeName": "_shop_2453267_",
    "hadDiscount": false,
    "discountAmount": 0
  },
  {
    "storeId": "2462340",
    "storeName": "_shop_2462340_",
    "hadDiscount": false,
    "discountAmount": 0
  },
  {
    "storeId": "2483437",
    "storeName": "_shop_2483437_",
    "hadDiscount": false,
    "discountAmount": 0
  },
  {
    "storeId": "2490408",
    "storeName": "_shop_2490408_",
    "hadDiscount": false,
    "discountAmount": 0
  },
  {
    "storeId": "2494261",
    "storeName": "_shop_2494261_",
    "hadDiscount": false,
    "discountAmount": 0
  },
  {
    "storeId": "2559480",
    "storeName": "_shop_2559480_",
    "hadDiscount": false,
    "discountAmount": 0
  },
  {
    "storeId": "2120525",
    "storeName": "_shop_2120525_",
    "hadDiscount": false,
    "discountAmount": 0
  },
  {
    "storeId": "2121527",
    "storeName": "_shop_2121527_",
    "hadDiscount": false,
    "discountAmount": 0
  },
  {
    "storeId": "2121779",
    "storeName": "_shop_2121779_",
    "hadDiscount": false,
    "discountAmount": 0
  },
  {
    "storeId": "2121792",
    "storeName": "_shop_2121792_",
    "hadDiscount": false,
    "discountAmount": 0
  },
  {
    "storeId": "2122041",
    "storeName": "_shop_2122041_",
    "hadDiscount": false,
    "discountAmount": 0
  },
  {
    "storeId": "2153702",
    "storeName": "_shop_2153702_",
    "hadDiscount": false,
    "discountAmount": 0
  },
  {
    "storeId": "2154878",
    "storeName": "_shop_2154878_",
    "hadDiscount": false,
    "discountAmount": 0
  },
  {
    "storeId": "2158980",
    "storeName": "_shop_2158980_",
    "hadDiscount": false,
    "discountAmount": 0
  },
  {
    "storeId": "2166495",
    "storeName": "_shop_2166495_",
    "hadDiscount": false,
    "discountAmount": 0
  },
  {
    "storeId": "2315610",
    "storeName": "_shop_2315610_",
    "hadDiscount": false,
    "discountAmount": 0
  },
  {
    "storeId": "2344950",
    "storeName": "_shop_2344950_",
    "hadDiscount": false,
    "discountAmount": 0
  },
  {
    "storeId": "2347856",
    "storeName": "_shop_2347856_",
    "hadDiscount": false,
    "discountAmount": 0
  },
  {
    "storeId": "2456564",
    "storeName": "_shop_2456564_",
    "hadDiscount": false,
    "discountAmount": 0
  },
  {
    "storeId": "2458109",
    "storeName": "_shop_2458109_",
    "hadDiscount": false,
    "discountAmount": 0
  },
  {
    "storeId": "2482137",
    "storeName": "_shop_2482137_",
    "hadDiscount": false,
    "discountAmount": 0
  },
  {
    "storeId": "2482469",
    "storeName": "_shop_2482469_",
    "hadDiscount": false,
    "discountAmount": 0
  },
  {
    "storeId": "2490592",
    "storeName": "_shop_2490592_",
    "hadDiscount": false,
    "discountAmount": 0
  },
  {
    "storeId": "2495663",
    "storeName": "_shop_2495663_",
    "hadDiscount": false,
    "discountAmount": 0
  },
  {
    "storeId": "2510874",
    "storeName": "_shop_2510874_",
    "hadDiscount": false,
    "discountAmount": 0
  },
  {
    "storeId": "2524341",
    "storeName": "_shop_2524341_",
    "hadDiscount": false,
    "discountAmount": 0
  },
  {
    "storeId": "2529767",
    "storeName": "_shop_2529767_",
    "hadDiscount": false,
    "discountAmount": 0
  },
  {
    "storeId": "2545786",
    "storeName": "_shop_2545786_",
    "hadDiscount": false,
    "discountAmount": 0
  },
  {
    "storeId": "2120487",
    "storeName": "_shop_2120487_",
    "hadDiscount": false,
    "discountAmount": 0
  },
  {
    "storeId": "2120530",
    "storeName": "_shop_2120530_",
    "hadDiscount": false,
    "discountAmount": 0
  },
  {
    "storeId": "2120826",
    "storeName": "_shop_2120826_",
    "hadDiscount": false,
    "discountAmount": 0
  },
  {
    "storeId": "2121511",
    "storeName": "_shop_2121511_",
    "hadDiscount": false,
    "discountAmount": 0
  },
  {
    "storeId": "2121810",
    "storeName": "_shop_2121810_",
    "hadDiscount": false,
    "discountAmount": 0
  },
  {
    "storeId": "2156698",
    "storeName": "_shop_2156698_",
    "hadDiscount": false,
    "discountAmount": 0
  },
  {
    "storeId": "2276456",
    "storeName": "_shop_2276456_",
    "hadDiscount": false,
    "discountAmount": 0
  },
  {
    "storeId": "2315287",
    "storeName": "_shop_2315287_",
    "hadDiscount": false,
    "discountAmount": 0
  },
  {
    "storeId": "2349375",
    "storeName": "_shop_2349375_",
    "hadDiscount": false,
    "discountAmount": 0
  },
  {
    "storeId": "2378162",
    "storeName": "_shop_2378162_",
    "hadDiscount": false,
    "discountAmount": 0
  },
  {
    "storeId": "2477802",
    "storeName": "_shop_2477802_",
    "hadDiscount": false,
    "discountAmount": 0
  },
  {
    "storeId": "2507226",
    "storeName": "_shop_2507226_",
    "hadDiscount": false,
    "discountAmount": 0
  },
  {
    "storeId": "2545820",
    "storeName": "_shop_2545820_",
    "hadDiscount": false,
    "discountAmount": 0
  },
  {
    "storeId": "2556939",
    "storeName": "_shop_2556939_",
    "hadDiscount": false,
    "discountAmount": 0
  },
  {
    "storeId": "2120543",
    "storeName": "_shop_2120543_",
    "hadDiscount": false,
    "discountAmount": 0
  },
  {
    "storeId": "2120792",
    "storeName": "_shop_2120792_",
    "hadDiscount": false,
    "discountAmount": 0
  },
  {
    "storeId": "2120800",
    "storeName": "_shop_2120800_",
    "hadDiscount": false,
    "discountAmount": 0
  },
  {
    "storeId": "2120849",
    "storeName": "_shop_2120849_",
    "hadDiscount": false,
    "discountAmount": 0
  },
  {
    "storeId": "2121780",
    "storeName": "_shop_2121780_",
    "hadDiscount": false,
    "discountAmount": 0
  },
  {
    "storeId": "2153720",
    "storeName": "_shop_2153720_",
    "hadDiscount": false,
    "discountAmount": 0
  },
  {
    "storeId": "2157472",
    "storeName": "_shop_2157472_",
    "hadDiscount": false,
    "discountAmount": 0
  },
  {
    "storeId": "2271894",
    "storeName": "_shop_2271894_",
    "hadDiscount": false,
    "discountAmount": 0
  },
  {
    "storeId": "2344346",
    "storeName": "_shop_2344346_",
    "hadDiscount": false,
    "discountAmount": 0
  },
  {
    "storeId": "2407988",
    "storeName": "_shop_2407988_",
    "hadDiscount": false,
    "discountAmount": 0
  },
  {
    "storeId": "2463479",
    "storeName": "_shop_2463479_",
    "hadDiscount": false,
    "discountAmount": 0
  },
  {
    "storeId": "2468507",
    "storeName": "_shop_2468507_",
    "hadDiscount": false,
    "discountAmount": 0
  },
  {
    "storeId": "2468609",
    "storeName": "_shop_2468609_",
    "hadDiscount": false,
    "discountAmount": 0
  },
  {
    "storeId": "2483771",
    "storeName": "_shop_2483771_",
    "hadDiscount": false,
    "discountAmount": 0
  },
  {
    "storeId": "2504483",
    "storeName": "_shop_2504483_",
    "hadDiscount": false,
    "discountAmount": 0
  },
  {
    "storeId": "2515607",
    "storeName": "_shop_2515607_",
    "hadDiscount": false,
    "discountAmount": 0
  },
  {
    "storeId": "2524446",
    "storeName": "_shop_2524446_",
    "hadDiscount": false,
    "discountAmount": 0
  },
  {
    "storeId": "2532763",
    "storeName": "_shop_2532763_",
    "hadDiscount": false,
    "discountAmount": 0
  },
  {
    "storeId": "2545785",
    "storeName": "_shop_2545785_",
    "hadDiscount": false,
    "discountAmount": 0
  },
  {
    "storeId": "2554442",
    "storeName": "_shop_2554442_",
    "hadDiscount": false,
    "discountAmount": 0
  },
  {
    "storeId": "2120827",
    "storeName": "_shop_2120827_",
    "hadDiscount": false,
    "discountAmount": 0
  },
  {
    "storeId": "2120844",
    "storeName": "_shop_2120844_",
    "hadDiscount": false,
    "discountAmount": 0
  },
  {
    "storeId": "2155996",
    "storeName": "_shop_2155996_",
    "hadDiscount": false,
    "discountAmount": 0
  },
  {
    "storeId": "2157471",
    "storeName": "_shop_2157471_",
    "hadDiscount": false,
    "discountAmount": 0
  },
  {
    "storeId": "2157473",
    "storeName": "_shop_2157473_",
    "hadDiscount": false,
    "discountAmount": 0
  },
  {
    "storeId": "2159524",
    "storeName": "_shop_2159524_",
    "hadDiscount": false,
    "discountAmount": 0
  },
  {
    "storeId": "2390228",
    "storeName": "_shop_2390228_",
    "hadDiscount": false,
    "discountAmount": 0
  },
  {
    "storeId": "2448395",
    "storeName": "_shop_2448395_",
    "hadDiscount": false,
    "discountAmount": 0
  },
  {
    "storeId": "2455471",
    "storeName": "_shop_2455471_",
    "hadDiscount": false,
    "discountAmount": 0
  },
  {
    "storeId": "2477323",
    "storeName": "_shop_2477323_",
    "hadDiscount": false,
    "discountAmount": 0
  },
  {
    "storeId": "2485859",
    "storeName": "_shop_2485859_",
    "hadDiscount": false,
    "discountAmount": 0
  },
  {
    "storeId": "2495664",
    "storeName": "_shop_2495664_",
    "hadDiscount": false,
    "discountAmount": 0
  },
  {
    "storeId": "2515959",
    "storeName": "_shop_2515959_",
    "hadDiscount": false,
    "discountAmount": 0
  },
  {
    "storeId": "2524337",
    "storeName": "_shop_2524337_",
    "hadDiscount": false,
    "discountAmount": 0
  },
  {
    "storeId": "2526461",
    "storeName": "_shop_2526461_",
    "hadDiscount": false,
    "discountAmount": 0
  },
  {
    "storeId": "2528772",
    "storeName": "_shop_2528772_",
    "hadDiscount": false,
    "discountAmount": 0
  },
  {
    "storeId": "2533924",
    "storeName": "_shop_2533924_",
    "hadDiscount": false,
    "discountAmount": 0
  },
  {
    "storeId": "2544467",
    "storeName": "_shop_2544467_",
    "hadDiscount": false,
    "discountAmount": 0
  },
  {
    "storeId": "2121002",
    "storeName": "_shop_2121002_",
    "hadDiscount": false,
    "discountAmount": 0
  },
  {
    "storeId": "2121004",
    "storeName": "_shop_2121004_",
    "hadDiscount": false,
    "discountAmount": 0
  },
  {
    "storeId": "2121018",
    "storeName": "_shop_2121018_",
    "hadDiscount": false,
    "discountAmount": 0
  },
  {
    "storeId": "2121023",
    "storeName": "_shop_2121023_",
    "hadDiscount": false,
    "discountAmount": 0
  },
  {
    "storeId": "2121037",
    "storeName": "_shop_2121037_",
    "hadDiscount": false,
    "discountAmount": 0
  },
  {
    "storeId": "2121124",
    "storeName": "_shop_2121124_",
    "hadDiscount": false,
    "discountAmount": 0
  },
  {
    "storeId": "2121291",
    "storeName": "_shop_2121291_",
    "hadDiscount": false,
    "discountAmount": 0
  },
  {
    "storeId": "2121827",
    "storeName": "_shop_2121827_",
    "hadDiscount": false,
    "discountAmount": 0
  },
  {
    "storeId": "2355932",
    "storeName": "_shop_2355932_",
    "hadDiscount": false,
    "discountAmount": 0
  },
  {
    "storeId": "2391698",
    "storeName": "_shop_2391698_",
    "hadDiscount": false,
    "discountAmount": 0
  },
  {
    "storeId": "2514932",
    "storeName": "_shop_2514932_",
    "hadDiscount": false,
    "discountAmount": 0
  },
  {
    "storeId": "2524552",
    "storeName": "_shop_2524552_",
    "hadDiscount": false,
    "discountAmount": 0
  },
  {
    "storeId": "2524554",
    "storeName": "_shop_2524554_",
    "hadDiscount": false,
    "discountAmount": 0
  },
  {
    "storeId": "2532734",
    "storeName": "_shop_2532734_",
    "hadDiscount": false,
    "discountAmount": 0
  },
  {
    "storeId": "2557161",
    "storeName": "_shop_2557161_",
    "hadDiscount": false,
    "discountAmount": 0
  },
  {
    "storeId": "2120880",
    "storeName": "_shop_2120880_",
    "hadDiscount": false,
    "discountAmount": 0
  },
  {
    "storeId": "2122039",
    "storeName": "_shop_2122039_",
    "hadDiscount": false,
    "discountAmount": 0
  },
  {
    "storeId": "2273871",
    "storeName": "_shop_2273871_",
    "hadDiscount": false,
    "discountAmount": 0
  },
  {
    "storeId": "2462792",
    "storeName": "_shop_2462792_",
    "hadDiscount": false,
    "discountAmount": 0
  },
  {
    "storeId": "2484773",
    "storeName": "_shop_2484773_",
    "hadDiscount": false,
    "discountAmount": 0
  },
  {
    "storeId": "2487401",
    "storeName": "_shop_2487401_",
    "hadDiscount": false,
    "discountAmount": 0
  },
  {
    "storeId": "2515782",
    "storeName": "_shop_2515782_",
    "hadDiscount": false,
    "discountAmount": 0
  },
  {
    "storeId": "2549220",
    "storeName": "_shop_2549220_",
    "hadDiscount": false,
    "discountAmount": 0
  },
  {
    "storeId": "2557876",
    "storeName": "_shop_2557876_",
    "hadDiscount": false,
    "discountAmount": 0
  },
  {
    "storeId": "2120478",
    "storeName": "_shop_2120478_",
    "hadDiscount": false,
    "discountAmount": 0
  },
  {
    "storeId": "2120798",
    "storeName": "_shop_2120798_",
    "hadDiscount": false,
    "discountAmount": 0
  },
  {
    "storeId": "2120872",
    "storeName": "_shop_2120872_",
    "hadDiscount": false,
    "discountAmount": 0
  },
  {
    "storeId": "2121586",
    "storeName": "_shop_2121586_",
    "hadDiscount": false,
    "discountAmount": 0
  },
  {
    "storeId": "2122028",
    "storeName": "_shop_2122028_",
    "hadDiscount": false,
    "discountAmount": 0
  },
  {
    "storeId": "2122043",
    "storeName": "_shop_2122043_",
    "hadDiscount": false,
    "discountAmount": 0
  },
  {
    "storeId": "2380087",
    "storeName": "_shop_2380087_",
    "hadDiscount": false,
    "discountAmount": 0
  },
  {
    "storeId": "2470879",
    "storeName": "_shop_2470879_",
    "hadDiscount": false,
    "discountAmount": 0
  },
  {
    "storeId": "2477052",
    "storeName": "_shop_2477052_",
    "hadDiscount": false,
    "discountAmount": 0
  },
  {
    "storeId": "2514810",
    "storeName": "_shop_2514810_",
    "hadDiscount": false,
    "discountAmount": 0
  },
  {
    "storeId": "2515083",
    "storeName": "_shop_2515083_",
    "hadDiscount": false,
    "discountAmount": 0
  },
  {
    "storeId": "2524340",
    "storeName": "_shop_2524340_",
    "hadDiscount": false,
    "discountAmount": 0
  },
  {
    "storeId": "2524889",
    "storeName": "_shop_2524889_",
    "hadDiscount": false,
    "discountAmount": 0
  },
  {
    "storeId": "2561334",
    "storeName": "_shop_2561334_",
    "hadDiscount": false,
    "discountAmount": 0
  },
  {
    "storeId": "2121071",
    "storeName": "_shop_2121071_",
    "hadDiscount": false,
    "discountAmount": 0
  },
  {
    "storeId": "2121101",
    "storeName": "_shop_2121101_",
    "hadDiscount": false,
    "discountAmount": 0
  },
  {
    "storeId": "2363789",
    "storeName": "_shop_2363789_",
    "hadDiscount": false,
    "discountAmount": 0
  },
  {
    "storeId": "2469056",
    "storeName": "_shop_2469056_",
    "hadDiscount": false,
    "discountAmount": 0
  },
  {
    "storeId": "2121717",
    "storeName": "_shop_2121717_",
    "hadDiscount": false,
    "discountAmount": 0
  }
];